/**
 * Resolves a url from a menu item entry object, returning the `devUrl` property
 * if it exists, & the app isn't running on the production site.
 * @param {{}} menuItem The menu item to resolve a url for.
 * @returns An environment-based url or empty string.
 */
export const resolveUrl = menuItem =>
  // @TODO Implement a better solution to use a dev URL vs prod.
  // Checks Window Location to see if `devUrl` should be used for a dev environment.
  (menuItem.devUrl && window.location.hostname !== 'minehut.com'
    ? menuItem.devUrl
    : menuItem.url) || '';
